module.exports = __webpack_public_path__ + "entry-logged-out-0d45d450/salary-illustration-2fecf8b2be2f1476a4abdf0e5c2d9628.svg";